import type { z } from 'zod';

import { indexSearchSchema, listParams } from '@nucleus-commerce/admin-kit/index-table';

import type { ReturnListParams } from '../api/returns-api';
import { RETURN_FILTER_FIELDS, RETURN_SORTS } from '../components/return-filters';

/** URL search params of the returns list; mirrors GET /admin/v1/stores/{storeId}/returns. */
export const returnListSearchSchema = indexSearchSchema(RETURN_FILTER_FIELDS, {
  sort: RETURN_SORTS,
});

export type ReturnListSearch = z.infer<typeof returnListSearchSchema>;

/** The list request for a validated search; the page's `useSearchListState().params` match it. */
export function returnListParams(search: ReturnListSearch): ReturnListParams {
  return listParams(search, RETURN_FILTER_FIELDS);
}
